import { OrganizationEntityType } from "@/lib/supabase/supabaseTypes";
import { TpValue } from "../types/enums";
import {
	DEFAULT_TEMPLATE_CONFIGURATION,
	PdfTemplateConfiguration,
} from "../context/PdfTemplateConfigurationContext";
import { PdfTemplateType } from "../pdf-templates/document-template.types";

export const logoImgUrlExample =
	"https://kzyysmmawuvnjxiemxqv.supabase.co/storage/v1/object/public/pub_img/b97620c3-fe56-4e31-9282-a1b66726e736/logos/2d7cae2c-7186-4988-8e4b-f70566e856f1/bwFWMqQ.png";

export const documentsConfigExample1: PdfTemplateConfiguration = {
	gs: {
		showLogo: true,
		footerText: {
			text: "Wir versichern, dass das Produkt für den oben erwähnten Patienten hergestellt wurde, und dass es den in Anhang I der RL93/42/EWG genannten grundlegenden Anforderungen entspricht.",
			width: 100,
		},
	},
	kv: {
		oneLiner: true,
		showLogo: true,
		footerText: {
			text: "<p>Wir versichern, dass alle Produkte für den oben erwähnten Patienten hergestellt wurde und den Anforderungen gemäss den medizinischen Richtlinen VIII der RL937427EWG entspricht.</p>",
			width: 100,
		},
		headerBodyGap: 5,
		showSignature: false,
		hideLabAddress: false,
		addressAlignment: "right",
		addressRtfEnabled: false,
	},
	ls: {
		oneLiner: true,
		showLogo: true,
		footerText: {
			text: "<p>Wir versichern, dass das Produkt für den oben erwähnten Patienten hergestellt wurde, und dass es den in Anhang I und insbesondere VIII der RL93/42/EWG genannten grundlegenden Anforderungen entspricht.</p>",
			width: 100,
		},
		idOneLiner: false,
		idAlignment: "left",
		idRtfEnabled: false,
		addressRtfEnabled: false,
		showVzlsMembership: true,
		absoluteRecipientAddress: false,
		recipientAddressAlignment: "right",
	},
	rg: {
		showLogo: true,
		footerText: {
			text: "",
			width: 100,
		},
		textAbovePaymentSlip: "Zahlbar innert 30 Tagen",
	},
	bar: { showLogo: true, footerText: { text: "", width: 100 } },
	srg: {
		showLogo: true,
		footerText: { text: "", width: 100 },
		textAbovePaymentSlip: "Zahlbar innert 30 Tagen",
	},
	karte: { showLogo: true, footerText: { text: "", width: 100 } },
	akonto: {
		showLogo: true,
		footerText: { text: "", width: 100 },
		textAbovePaymentSlip: "Zahlbar innert 30 Tagen",
	},
	general: {
		email: "zahntechnik.abc@def.ch",
		logoSize: 25,
		oneLiner: true,
		marginTop: 10,
		idOneLiner: false,
		logoImgurl: logoImgUrlExample,
		marginLeft: 20,
		showBorder: false,
		idAlignment: "left",
		marginRight: 20,
		idRtfEnabled: false,
		marginBottom: 10,
		headerBodyGap: 2,
		logoAlignment: "center",
		customIconPath: "",
		hideLabAddress: true,
		showSwissLabel: false,
		footerAlignment: "center",
		addressAlignment: "right",
		commentAlignment: "left",
		addressRtfEnabled: false,
		clientAddressLeft: true,
		showVzlsMembership: true,
		absoluteRecipientAddress: false,
		organizationsImgPosition: "top",
		organizationsImgAlignment: "left",
		recipientAddressAlignment: "right",
		website: "https://www.zahntechnik-meier.ch",
	},
	mahnung_1: {
		...DEFAULT_TEMPLATE_CONFIGURATION[PdfTemplateType.ERSTE_MAHNUNG],
		showLogo: true,
		footerText: { text: "", width: 100 },
	},
	mahnung_2: {
		...DEFAULT_TEMPLATE_CONFIGURATION[PdfTemplateType.FOLGEMAHNUNG],
		showLogo: true,
		footerText: { text: "", width: 100 },
	},
	letzte_mahnung: {
		...DEFAULT_TEMPLATE_CONFIGURATION[PdfTemplateType.LETZTE_MAHNUNG],
		showLogo: true,
		footerText: { text: "", width: 100 },
	},
	rg_doppel: { showLogo: true, footerText: { text: "", width: 100 } },
	auftragsblatt: { showLogo: true, footerText: { text: "", width: 100 } },
	zahlungserinnerung: {
		...DEFAULT_TEMPLATE_CONFIGURATION[PdfTemplateType.ZAHLUNGSERINNERUNG],
		showLogo: true,
		footerText: { text: "", width: 100 },
	},
	etik_auftrag: {
		showLogo: false,
		footerText: { text: "", width: 0 },
		showToothColor: false,
	},
};

export const documentsConfigExample2: PdfTemplateConfiguration = {
	gs: {
		showLogo: true,
		footerText: {
			text: "Wir versichern, dass das Produkt für den oben erwähnten Patienten hergestellt wurde, und dass es den in Anhang I der RL93/42/EWG genannten grundlegenden Anforderungen entspricht.",
			width: 100,
		},
	},
	kv: {
		showLogo: true,
		footerText: {
			text: "<p>Die angegebenen Kosten können bis zu 15% abweichen. Falls zusätzliche Arbeiten notwendig werden, die einen grösseren Mehraufwand bedingen, werden wir Sie darauf aufmerksam machen.</p>",
			width: 100,
		},
		showSignature: false,
	},
	ls: {
		showLogo: true,
		footerText: {
			text: "<p>Wir versichern, dass das Produkt für den oben erwähnten Patienten hergestellt wurde, und dass es den in Anhang I und insbesondere VIII der RL93/42/EWG genannten grundlegenden Anforderungen entspricht.</p>",
			width: 100,
		},
	},
	rg: {
		showLogo: true,
		footerText: {
			text: "",
			width: 100,
		},
		textAbovePaymentSlip: "Zahlbar innert 30 Tagen",
	},
	bar: { showLogo: true, footerText: { text: "", width: 100 } },
	srg: {
		showLogo: true,
		footerText: { text: "", width: 100 },
		textAbovePaymentSlip: "Zahlbar innert 30 Tagen",
	},
	karte: { showLogo: true, footerText: { text: "", width: 100 } },
	akonto: {
		showLogo: true,
		footerText: { text: "", width: 100 },
		textAbovePaymentSlip: "Zahlbar innert 30 Tagen",
	},
	general: {
		email: "",
		hideIds: true,
		logoSize: 49,
		oneLiner: false,
		marginTop: 20,
		logoImgurl: logoImgUrlExample,
		marginLeft: 25,
		hideMembers: true,
		marginRight: 10,
		idRtfEnabled: true,
		marginBottom: 10,
		logoAlignment: "left",
		customIconPath: "",
		hideLabAddress: true,
		showSwissLabel: false,
		footerAlignment: "center",
		addressAlignment: "left",
		commentAlignment: "left",
		addressRtfEnabled: false,
		clientAddressLeft: true,
		showVzlsMembership: false,
		absoluteRecipientAddress: true,
		organizationsImgPosition: "top",
		organizationsImgAlignment: "left",
		recipientAddressAlignment: "right",
		website: "https://www.zahntechnik-meier.ch",
	},
	mahnung_1: {
		...DEFAULT_TEMPLATE_CONFIGURATION[PdfTemplateType.ERSTE_MAHNUNG],
		showLogo: true,
		footerText: { text: "", width: 100 },
	},
	mahnung_2: {
		...DEFAULT_TEMPLATE_CONFIGURATION[PdfTemplateType.FOLGEMAHNUNG],
		showLogo: true,
		footerText: { text: "", width: 100 },
	},
	letzte_mahnung: {
		...DEFAULT_TEMPLATE_CONFIGURATION[PdfTemplateType.LETZTE_MAHNUNG],
		showLogo: true,
		footerText: { text: "", width: 100 },
	},
	rg_doppel: { showLogo: true, footerText: { text: "", width: 100 } },
	auftragsblatt: { showLogo: true, footerText: { text: "", width: 100 } },
	zahlungserinnerung: {
		...DEFAULT_TEMPLATE_CONFIGURATION[PdfTemplateType.ZAHLUNGSERINNERUNG],
		showLogo: true,
		footerText: { text: "", width: 100 },
	},
	etik_auftrag: {
		showLogo: false,
		footerText: { text: "", width: 0 },
		showToothColor: false,
	},
};

export const documentsConfigExample3: PdfTemplateConfiguration = {
	gs: {
		showLogo: true,
		footerText: {
			text: "Wir versichern, dass das Produkt für den oben erwähnten Patienten hergestellt wurde, und dass es den in Anhang I der RL93/42/EWG genannten grundlegenden Anforderungen entspricht.",
			width: 0,
		},
	},
	kv: {
		showLogo: true,
		footerText: {
			text: "<p>Die angegebenen Kosten können bis zu 15% abweichen. Falls zusätzliche Arbeiten notwendig werden, die einen grösseren Mehraufwand bedingen, werden wir Sie darauf aufmerksam machen.</p>",
			width: 0,
		},
		showSignature: false,
	},
	ls: {
		showLogo: true,
		footerText: {
			text: "<p>Wir versichern, dass das Produkt für den oben erwähnten Patienten hergestellt wurde, und dass es den in Anhang I und insbesondere VIII der RL93/42/EWG genannten grundlegenden Anforderungen entspricht.</p>",
			width: 0,
		},
	},
	rg: {
		showLogo: true,
		footerText: { text: "", width: 0 },
		textAbovePaymentSlip: "Zahlbar innert 30 Tagen",
	},
	bar: { showLogo: true, footerText: { text: "", width: 0 } },
	srg: {
		showLogo: true,
		footerText: { text: "", width: 0 },
		textAbovePaymentSlip: "Zahlbar innert 30 Tagen",
	},
	karte: { showLogo: true, footerText: { text: "", width: 0 } },
	akonto: {
		showLogo: true,
		footerText: { text: "", width: 0 },
		textAbovePaymentSlip: "Zahlbar innert 30 Tagen",
	},
	general: {
		size: "md",
		email: "",
		hideIds: true,
		logoSize: 49,
		oneLiner: false,
		marginTop: 20,
		logoImgurl:
			"https://zukcvpobsngdbpoajqcb.supabase.co/storage/v1/object/public/pub_img/7c5113fa-4796-4460-8bdf-7792b289a7c3/logos/cb8f6006-8f06-4641-b250-20a70abddea4/1B68C606-D575-42C0-9A37-E48C74839CB4.jpg",
		marginLeft: 25,
		hideMembers: true,
		marginRight: 10,
		idRtfEnabled: true,
		marginBottom: 10,
		logoAlignment: "left",
		customIconPath: "",
		hideLabAddress: true,
		showSwissLabel: false,
		footerAlignment: "center",
		addressAlignment: "left",
		commentAlignment: "left",
		addressRtfEnabled: false,
		clientAddressLeft: true,
		showVzlsMembership: false,
		absoluteRecipientAddress: true,
		organizationsImgPosition: "top",
		organizationsImgAlignment: "left",
		recipientAddressAlignment: "right",
		website: "https://www.zahntechnik-meier.ch",
	},
	mahnung_1: {
		...DEFAULT_TEMPLATE_CONFIGURATION[PdfTemplateType.ERSTE_MAHNUNG],
		showLogo: true,
		footerText: { text: "", width: 0 },
	},
	mahnung_2: {
		...DEFAULT_TEMPLATE_CONFIGURATION[PdfTemplateType.FOLGEMAHNUNG],
		showLogo: true,
		footerText: { text: "", width: 0 },
	},
	letzte_mahnung: {
		...DEFAULT_TEMPLATE_CONFIGURATION[PdfTemplateType.LETZTE_MAHNUNG],
		showLogo: true,
		footerText: { text: "", width: 0 },
	},
	rg_doppel: { showLogo: true, footerText: { text: "", width: 0 } },
	auftragsblatt: { showLogo: true, footerText: { text: "", width: 0 } },
	zahlungserinnerung: {
		...DEFAULT_TEMPLATE_CONFIGURATION[PdfTemplateType.ZAHLUNGSERINNERUNG],
		showLogo: true,
		footerText: { text: "", width: 0 },
	},
	etik_auftrag: {
		showLogo: false,
		footerText: { text: "", width: 0 },
		showToothColor: false,
	},
};

export const documentsConfigExample4: PdfTemplateConfiguration = {
	gs: {
		showLogo: true,
		footerText: {
			text: "Wir versichern, dass das Produkt für den oben erwähnten Patienten hergestellt wurde, und dass es den in Anhang I der RL93/42/EWG genannten grundlegenden Anforderungen entspricht.",
			width: 0,
		},
	},
	kv: {
		showLogo: true,
		footerText: {
			text: "Die angegebenen Kosten können bis zu 15% abweichen. Falls zusätzliche Arbeiten notwendig werden, die einen grösseren Mehraufwand bedingen, werden wir Sie darauf aufmerksam machen.",
			width: 180,
		},
		showSignature: false,
	},
	ls: {
		showLogo: true,
		footerText: {
			text: "Wir versichern, dass das Produkt für den oben erwähnten Patienten hergestellt wurde, und dass es den in Anhang I und insbesondere VIII der RL93/42/EWG genannten grundlegenden Anforderungen entspricht.",
			width: 0,
		},
	},
	rg: {
		showLogo: true,
		footerText: { text: "", width: 0 },
		textAbovePaymentSlip: "Zahlbar innert 30 Tagen",
	},
	bar: { showLogo: true, footerText: { text: "", width: 0 } },
	srg: {
		showLogo: true,
		footerText: { text: "", width: 0 },
		textAbovePaymentSlip: "Zahlbar innert 30 Tagen",
	},
	karte: { showLogo: true, footerText: { text: "", width: 0 } },
	akonto: {
		showLogo: true,
		footerText: { text: "", width: 0 },
		textAbovePaymentSlip: "Zahlbar innert 30 Tagen",
	},
	general: {
		size: "lg",
		email: "labor.casellini@gmx.ch",
		oneLiner: false,
		marginTop: 5,
		idOneLiner: true,
		marginLeft: 20,
		showBorder: true,
		idAlignment: "left",
		marginRight: 10,
		marginBottom: 10,
		customIconPath: "",
		hideLabAddress: false,
		showSwissLabel: true,
		footerAlignment: "center",
		addressAlignment: "left",
		commentAlignment: "left",
		addressRtfEnabled: false,
		clientAddressLeft: true,
		showVzlsMembership: true,
		absoluteRecipientAddress: true,
		organizationsImgPosition: "top",
		organizationsImgAlignment: "right",
		recipientAddressAlignment: "right",
		website: "https://www.zahntechnik-meier.ch",
	},
	mahnung_1: {
		...DEFAULT_TEMPLATE_CONFIGURATION[PdfTemplateType.ERSTE_MAHNUNG],
		showLogo: true,
		footerText: { text: "", width: 0 },
	},
	mahnung_2: {
		...DEFAULT_TEMPLATE_CONFIGURATION[PdfTemplateType.FOLGEMAHNUNG],
		showLogo: true,
		footerText: { text: "", width: 0 },
	},
	letzte_mahnung: {
		...DEFAULT_TEMPLATE_CONFIGURATION[PdfTemplateType.LETZTE_MAHNUNG],
		showLogo: true,
		footerText: { text: "", width: 0 },
	},
	rg_doppel: { showLogo: true, footerText: { text: "", width: 0 } },
	auftragsblatt: { showLogo: true, footerText: { text: "", width: 0 } },
	zahlungserinnerung: {
		...DEFAULT_TEMPLATE_CONFIGURATION[PdfTemplateType.ZAHLUNGSERINNERUNG],
		showLogo: true,
		footerText: { text: "", width: 0 },
	},
	etik_auftrag: {
		showLogo: false,
		footerText: { text: "", width: 0 },
		showToothColor: false,
	},
};

export const organizationExample: OrganizationEntityType = {
	id: "f8a40125-f4c5-41d0-a738-874d990c71c9",
	created_at: "2024-04-21T10:22:04.555285+00:00",
	modified_at: "2024-04-21T10:22:04.555285+00:00",
	name: "Zahntechnik Meier",
	unique_name: null,
	title_or_company_name: "Zahntechnik Meier AG",
	name_or_additional_information: "Inhaber: Hans Meier",
	street: "Hauptstrasse 15",
	city: "Zürich",
	postal_code: "8000",
	phone_and_fax: "+41775243223",
	gln: "1234567891111",
	documents_config: JSON.stringify(documentsConfigExample1),
	organization_connect_info_id: null,
	agenda_config: null,
	client_page_config: null,
	days_payment: 30,
	days_payment_akonto: 14,
	days_payment_mahnung_1: 14,
	days_payment_mahnung_2: 14,
	days_payment_reminder: 14,
	internet_config: null,
	is_book_camt54: true,
	is_monthly_discount_on_total: false,
	is_mwst_eust: false,
	mwst_number: null,
	mwst_percentage: 8.1,
	is_print_qr_inv: true,
	mahnung_max_count: 2,
	reminder_fee_amounts: {},
	reminder_due_basis: "invoice_date",
	show_reminder_sidebar_badge: false,
	round_to: 4,
	sms_config: null,
	email: "info@zahntechnik-mueller.ch",
	ct_avatar_path: null,
	ct_display_name: null,
	is_analytics: true,
	konfiguration: null,
	default_tp_value: TpValue.OLD,
	default_bank_account_id: 1,
	country: "CH",
	stripe_data: null,
	trial_period_end: null,
	profile_colors: null,
	config: null,
	is_onboarded: false,
	zak_contract_no: null,
	zak_order_number: null,
	zak_password: null,
	zak_username: null,
	default_activated_region_id: null,
	default_job_tabs_config_id: null,
	default_price_list_id: null,
	default_catalogs_custom_id: null,
	default_catalogs_default_id: null,
	service_catalog: null,
	currency_text: "CHF",
	subscription_tier: "full",
	billing_region: null,
};
